import { render } from "./StaffEdit.vue?vue&type=template&id=9a22e910"
import script from "./StaffEdit.vue?vue&type=script&lang=js"
export * from "./StaffEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__